export default __webpack_public_path__ + "static/aibRedWhite-2b7facf002fc8e73c69294ce017cf764.webp";